import './App.css';
import { BrowserRouter } from 'react-router-dom';
import AllRoutes from './components/AllRoutes';
import { NavbarDev } from './components/NavbarDev';
import FooterV2 from './components/sections/FooterV2';

function App() {
  return (
    <BrowserRouter>
      {/* <Navbar/> */}
      <NavbarDev/>
      <AllRoutes />
      <FooterV2/>
    </BrowserRouter>
  );
}

export default App;
